export const PRODUCTS_LOADED = 'products.LOADED';
export const PRODUCTS_SALES_DATA_LOADED = 'products.SALES_DATA_LOADED';

export const PRODUCTS_RESET_MONTHLY_SALES = 'products.PRODUCTS_RESET_MONTHLY_SALES';

export const PRODUCTS_UPDATE_COUCH_SELLING_PRICE = 'products.UPDATE_COUCH_SELLING_PRICE';
export const PRODUCTS_UPDATE_CHAIR_SELLING_PRICE = 'products.UPDATE_CHAIR_SELLING_PRICE';
export const PRODUCTS_UPDATE_TABLE_SELLING_PRICE = 'products.UPDATE_TABLE_SELLING_PRICE';

export const PRODUCTS_SOLD = 'products.SOLD';
export const PRODUCTS_SOLD_COUCH = 'products.SOLD_COUCH';
export const PRODUCTS_SOLD_CHAIR = 'products.SOLD_CHAIR';
export const PRODUCTS_SOLD_TABLE = 'products.SOLD_TABLE';

export const PRODUCTS_PURCHASED = 'products.PURCHASED';
export const PRODUCTS_COUCH_PURCHASED = 'products.COUCH_PURCHASED';
export const PRODUCTS_CHAIR_PURCHASED = 'products.CHAIR_PURCHASED';
export const PRODUCTS_TABLE_PURCHASED = 'products.TABLE_PURCHASED';
